<div class="landing-page" [appSpinner]="isLoading">

<app-quick-action-manager [userActionsList]="quickActionsService.userActionsList"
                          [isLoading]="isLoading"
                          [isCreateMessageTypesEmpty]="isCreateMessageTypesEmpty"
></app-quick-action-manager>

  <div class="action-buttons-menu-wrapper">
    <button mat-icon-button [matMenuTriggerFor]="menu" id="quick-actions-button"  *ngIf=" !isLoading" >
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="onChangeQuickActionsClick()" >
        <span>{{'messages_center.landing_page.change_quick_actions' | translate}}</span>
      </button>
    </mat-menu>
  </div>
</div>

